import { render, staticRenderFns } from "./CampoVazioMensagem.vue?vue&type=template&id=8f10a7fc"
import script from "./CampoVazioMensagem.vue?vue&type=script&lang=js"
export * from "./CampoVazioMensagem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports